export interface QuizOfferConfig { offerKey: string; durationDays: number; endDate: string; deadlineType?: string }
type OfferStorage = Pick<Storage, 'getItem' | 'setItem'>

export const offerStorageKey = (offerKey: string) => `pvolve:longevity-offer:${encodeURIComponent(offerKey.trim())}:v1`

function fixedDeadline(value: string): number | null {
	// Explicit timezone: visitor device locale must not move a merchant's deadline.
	const parts = /^(\d{4})-(\d{2})-(\d{2})T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.exec(value)
	if (!parts) return null
	const [, year, month, day] = parts.map(Number)
	if (month < 1 || month > 12 || day < 1 || day > new Date(Date.UTC(year, month, 0)).getUTCDate()) return null
	const parsed = Date.parse(value)
	return Number.isFinite(parsed) ? parsed : null
}

/** Fixed campaigns share an end; first-visit deadlines persist and never extend or renew. */
export function offerDeadline(config: QuizOfferConfig, storage: OfferStorage | null, now: number): number | null {
	const endDate = config.endDate.trim()
	const campaignEnd = endDate ? fixedDeadline(endDate) : null
	const deadlineType = config.deadlineType || 'first_visit'
	if (deadlineType === 'fixed_campaign') return campaignEnd
	if (deadlineType !== 'first_visit') return null
	if (endDate && campaignEnd === null) return null
	if (!config.offerKey.trim() || !Number.isInteger(config.durationDays) || config.durationDays < 1 || config.durationDays > 30 || !storage) return null
	try {
		const key = offerStorageKey(config.offerKey)
		const saved = storage.getItem(key)
		let expiry = now + config.durationDays * 86400000
		if (saved !== null) {
			const value = Number(saved)
			if (!/^\d+$/.test(saved) || !Number.isSafeInteger(value) || value <= 0) return null
			expiry = value
		}
		if (campaignEnd !== null) expiry = Math.min(expiry, campaignEnd)
		if (saved !== String(expiry)) storage.setItem(key, String(expiry))
		return expiry
	} catch {
		return null
	}
}

export function countdownParts(remainingMs: number, showDays: boolean) {
	const total = Math.max(0, Math.ceil(remainingMs / 1000))
	return {
		days: showDays ? Math.floor(total / 86400) : 0,
		hours: showDays ? Math.floor(total / 3600) % 24 : Math.floor(total / 3600),
		minutes: Math.floor(total / 60) % 60,
		seconds: total % 60,
	}
}
